import AddSaleFnsMixin from '../AddSaleFnsMixin';
import ProductsTable from '../../components/productsTable/ProductsTable.vue';
import Photo from '../../../../sharedComponents/photo/Photo.vue';

export default {
  name: 'AddSaleFnsTable',
  mixins: [AddSaleFnsMixin],
  components: { ProductsTable, Photo },
  data() {
    return {
      checkQr: false,
    };
  },
  computed: {
    salesTicket() {
      return this.$store.state.sales.salesTicket;
    },
    ticket() {
      if (this.id === 'null') {
        return null;
      }
      return this.salesTicket.find(el => el.id === Number(this.id));
    },
    // Продукты акции
    products() {
      // Берём акцию из маршрута: actions.ticket - лишь последняя актуальная акция этого типа
      const actionId = Number(this.action_id);
      const action = (this.$store.state.sales.currentActions ?? [])
        .find(el => el.id === actionId);
      // Завершённой акции нет в currentActions - берём из продажи
      return action?.products ?? this.sale?.action?.products ?? null;
    },
  },

  methods: {
    onCheckQr(value) {
      this.checkQr = value;
    },
    /**
     * Метод добавления новой продажи.
     */
    onSubmit(isDraft = false) {
      this.submitIsProcessing = true;
      const app = this;
      let restURL = 'sales/api/sale-fns/create';
      const sale = {
        register_type: 'web',
        ...this.form,
        positions: this.$refs.table.getPositions(),
        is_draft: isDraft,
        profile_id: this.user.profile_id,
        action_id: this.action_id,
      };
      sale.ttn_sum = sale.ttn_sum ? Number(sale.ttn_sum) : null;

      if (app.saleID !== 'null') {
        restURL = 'sales/api/sale-fns/update';
        sale.sale_id = app.sale.id;
        sale.action_id = app.sale.action_id;
        sale.register_type = 'web';
      }

      app.$store.getters.axl
        .post(restURL, sale)
        .then(() => {
          this.$store.dispatch('sales/GetSales', {
            profile_id: this.$store.state.user.profile_id,
          });
          app.$router.push('/sales/purchase');
          app.$store.dispatch('ShowInfo', 'Монтаж отправлен на проверку');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        })
        .finally(() => {
          this.submitIsProcessing = false;
        });
    },
    /** Записать дату */
    SaveDate(date) {
      this.$refs.menu.save(date);
    },
    /** Форматировать дату */
    FormatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
  },
  created() {
    // При прямом заходе по ссылке список акций ещё не загружен
    if (!this.$store.state.sales.currentActions) {
      this.$store.dispatch('sales/GetActionsList', {
        profile_id: this.user.profile_id,
      });
    }
  },
};
